import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import VerifyPage from './VerifyPage';
import DashboardPage from './DashboardPage';
import StudentsPage from './StudentsPage';
import TrainersPage from './TrainersPage';
import CoursesPage from './CoursesPage';
import TemplateCRUDPage from './TemplateCRUDPage';
import ChatPage from './ChatPage';
import ContactPage from './ContactPage';
import ResourcesPage from './ResourcesPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/students" element={<StudentsPage />} />
        <Route path="/trainers" element={<TrainersPage />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/templates" element={<TemplateCRUDPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/chats" element={<ChatPage />} />
        <Route path="/contacts" element={<ContactPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
